import './App.css';
import { router, } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React from 'react'
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary'
import PushPrompt from './Components/PushPrompt/PushPrompt'
import OfferCountdown from './Components/OfferCountdown/OfferCountdown'
import AbandonedCartTracker from './Components/AbandonedCartTracker/AbandonedCartTracker'
import FunnelTracker from './Components/FunnelTracker/FunnelTracker'
import ComboBuilder from './Components/ComboBuilder/ComboBuilder'


function App() {


  return (

    <ErrorBoundary><><OfferCountdown /><FunnelTracker /><ComboBuilder /><AbandonedCartTracker /><RouterProvider router={router} /><PushPrompt /></></ErrorBoundary>

  );
}

export default App;
